import { render, staticRenderFns } from "./CreatePostBuildStep.vue?vue&type=template&id=5de22ace"
import script from "./CreatePostBuildStep.vue?vue&type=script&lang=js"
export * from "./CreatePostBuildStep.vue?vue&type=script&lang=js"
import style0 from "./CreatePostBuildStep.vue?vue&type=style&index=0&id=5de22ace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports